import React from 'react';
import Headroom from 'react-headroom';
// Components
import { MenuToggle } from './menuToggle';
import { HomeLink } from './homeLink';
import { DrawNav } from './drawNav';
import { CartFlyout } from '../cart/cartFlyout';

// Hooks / State
import { useAppState } from '../../state/appState';

export const Header = () => {
  const { navOpen, reverseHeader, toggleNavOpen, setHeaderPinned, headerPinned } = useAppState();
  return (
    <>
      <Headroom
        style={{ zIndex: '1000' }}
        onPin={() => setHeaderPinned(true)}
        onUnpin={() => setHeaderPinned(false)}
        onUnfix={() => setHeaderPinned(false)}
      >
        <header
          className={`py-4 md:py-8 px-gutter z-50 flex items-center justify-between w-full transition-all ${
            navOpen || reverseHeader || headerPinned ? 'text-sand' : 'text-marphonaBrown'
          } ${headerPinned && 'bg-marphonaBrown'}`}
        >
          <MenuToggle isOpen={navOpen} onClick={toggleNavOpen} />
          <HomeLink navOpen={navOpen} />
        </header>
      </Headroom>
      <DrawNav />
      <CartFlyout />
    </>
  );
};
